function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// @ts-strict-ignore
import JSURL from 'jsurl';
import { ReportName } from 'common/report/constants';
import { ReportHeader, ReportHeaderJsxProps } from 'common/report/report-manager/report-header';
import { InsightsQueryResults } from 'common/report/insights/util/types';
import { InsightsBookmarkParams } from 'common/types/reports/bookmark';
import { getResultsKeysAndValues } from 'common/report/insights/util';
import { hasValidMetricBookmarkShowClauses } from 'common/report/insights/contexts/validation';
import { SearchDisplayContext } from 'common/report/util/search/types';
import { defineAndMakeJsxFactory } from 'common/util/jsx';
import { panel2react } from 'common/util/react';
import { TimeUnit } from 'common/widgets/date-range-picker/models/types';
import { HeaderCustomAlertParams } from 'common/query-builder/query-report-header/types';
import { Section, TimeSection } from 'common/report/insights/models/section';
import { isCustomAlertConditionTypesEnabled, isValidAnomalyDetectionBookmark } from 'common/widgets/alerts/custom-alert/utils';
import { Report } from '../models/report';
import { getDateRange } from '../util/time';
import { TimeClause } from '../models/time-clause';
import { getInsightsMetricsLimit } from '../util/metrics';
export class InsightsReportHeader extends ReportHeader<InsightsBookmarkParams, InsightsQueryResults> {
  constructor() {
    super(...arguments);
    _defineProperty(this, "displayContext", SearchDisplayContext.Insights);
    _defineProperty(this, "reportType", ReportName.Insights);
    _defineProperty(this, "customAlertsEnabled", true);
    _defineProperty(this, "csvExportEnabled", true);
  }
  public reportHeaderCustomAlertParams(): HeaderCustomAlertParams {
    var _this$bookmark$params;
    const timeUnit = (_this$bookmark$params = this.bookmark.params.sections.time[0].unit) !== null && _this$bookmark$params !== void 0 ? _this$bookmark$params : TimeUnit.Day;
    // Cleanup: Improve typing for Section.deserialize
    const timeSection = Section.deserialize(TimeSection.TYPE, this.bookmark.params.sections.time) as {
      clauses: TimeClause[];
    };
    const dateRange = getDateRange(timeSection.clauses);
    return {
      isCustomAlertsActionVisible: true,
      resultsKeysAndValues: getResultsKeysAndValues(this.bookmark.params, this.results, this.dataGroups, this.bookmark.type, this.getContext("i18n")),
      customAlertIntervalDays: dateRange.getIntervalDays(),
      customAlertTimeUnit: timeUnit,
      enableCustomAlertConditionTypes: isCustomAlertConditionTypesEnabled(this.bookmark.type, this.bookmark.params),
      enableAnomalyDetectionControls: isValidAnomalyDetectionBookmark(this.bookmark.type, this.bookmark.params),
      bookmarkParams: this.bookmark.params
    };
  }
  getInvalidParamsMessage(): string {
    if (!hasValidMetricBookmarkShowClauses(this.bookmark.params.sections.show)) {
      return this.t("reports.actions.saving.tooltips.needs-event");
    }

    // Keep this as the last check. We ignore this message when updating an existing report,
    // and any messages below this will get swallowed by that logic.
    // TODO: Remove this comment once we stop supporting existing reports over the metric limit.
    const metricsLimit = getInsightsMetricsLimit(this.project);
    if (metricsLimit && this.bookmark.params.sections.show.length > metricsLimit) {
      return this.t("reports.actions.duplicate-disabled-tooltip");
    }
    return null;
  }
  getStandaloneHash(titleOverride?: string) {
    const report = Report.fromBookmarkData(this.bookmark.params);
    if (titleOverride) {
      report.title = titleOverride;
    }
    const stringifiedReport = JSURL.stringify(report.toUrlData());
    if (this.bookmark.id && !titleOverride) {
      return "report/".concat(this.bookmark.id, "/").concat(stringifiedReport);
    }
    return stringifiedReport;
  }
}
export const InsightsReportHeaderEl = defineAndMakeJsxFactory<ReportHeaderJsxProps>("insights-report-header", InsightsReportHeader);
export const InsightsReportHeaderReact = panel2react<ReportHeaderJsxProps>("insights-report-header", InsightsReportHeader);